export default function extend(...args) {
  return Object.assign(...args)
}